import { render, staticRenderFns } from "./LogoutBtn.vue?vue&type=template&id=5e576af7&scoped=true&"
import script from "./LogoutBtn.vue?vue&type=script&lang=js&"
export * from "./LogoutBtn.vue?vue&type=script&lang=js&"
import style0 from "./LogoutBtn.vue?vue&type=style&index=0&id=5e576af7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e576af7",
  null
  
)

export default component.exports